import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import DramaDetail from "@/pages/detail/page";
import EpisodeDetail from "@/pages/detail/episode/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <Category /> },
      { path: "detail/:id", element: <DramaDetail /> },
      { path: "detail/:id/episode/:episodeId", element: <EpisodeDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;